import req from 'utils/req';
import lscache from 'lscache';
import queryString from 'query-string';
import { isCordova } from 'utils/platform';
import featureFlags from 'featureFlags';
import { serializeConsentCookies } from '../providers/CookieConsentProvider';
import useAuthStore from "~/authentication/store";
import { WlWindow } from '../../typings/globals/cordova';
import { isAndroidApp } from 'utils/platform';
import { forceTokenRemoval } from 'modules/authentication/helpers/nextauth';

declare const window: WlWindow;

function addDefaultQueryParams(url) {
  const params: any = {};

  if (isCordova()) {
    params.utm_source = 'app';
    params.utm_medium = ANALYTICS_PLATFORM;
  }

  const paramString = queryString.stringify(params);

  if (url.indexOf('?') > -1) {
    return `${url}&${paramString}`;
  } else {
    return `${url}?${paramString}`;
  }
}
export function fetchAuthenticationMailTokenForPizza(url) {
  const serializedConsentState = serializeConsentCookies();
  const queryparams = `cc=${serializedConsentState}&ff=${featureFlags.serializeFeatureFlags()}&url=${encodeURIComponent(
    url
  )}`;
  return req(`${URL_API_HOST}/api/v1/authentication/mailtoken`)
    .post()
    .then(({ token }) => {
      return `${URL_SECURE_HOST}/token/${token}/?${queryparams}`;
    })
    .catch(() => {
      return url;
    });
}

export function fetchAuthenticationMailTokenUrl(url) {
  return req(`${URL_API_HOST}/api/v1/authentication/mailtoken`)
    .post()
    .then((result) => {
      return `${result.url}&url=${encodeURIComponent(url)}`;
    })
    .catch(() => {
      return url;
    });
}


function addCurrencyParam(url) {
  const currency = lscache.get('currency');
  const ignoreCurrency =
    url.indexOf('/customtrip/') > -1 || url.indexOf('/booking/') > -1;

  if (currency && url.indexOf('#') === -1 && !ignoreCurrency) {
    return (url += '#currency=' + currency);
  }
  return url;
}

export function getSecureLoginLink(url) {
  return fetchAuthenticationMailTokenForPizza(
    addCurrencyParam(addDefaultQueryParams(url))
  );
}

export async function openExternalLink(url: string, openInNewTab = true, tries = 0) {
  const urlWithDefaultParams = addDefaultQueryParams(url);

  if (!isCordova()) {
    const target = openInNewTab ? '_blank' : '_self';
    window.open(urlWithDefaultParams, target);
    return;
  }

  const tokenFromStorage = useAuthStore.getState().token;

  const requestOptions: { [key: string]: any } = {
    method: 'POST',
    credentials: 'include'
  };

  if (tokenFromStorage) {
    requestOptions.headers = { Authorization: `Bearer ${tokenFromStorage}` };
  }

  try {
    const shortLivedTokenResponse = await fetch(
      `${URL_AUTHENTICATION_HOST}/api/v1/auth/token/short/`,
      requestOptions
    );

    const shortLivedTokenResponseJson = await shortLivedTokenResponse.json();

    const shortLivedToken = shortLivedTokenResponseJson.token;
    const searchParams = new URLSearchParams();

    if (shortLivedToken) {
      searchParams.set('token', shortLivedToken);
    }
    searchParams.set('redirect_uri', urlWithDefaultParams);
    window.open(`${URL_AUTHENTICATION_HOST}/api/v1/auth/token/short/?${searchParams.toString()}`, '_system');
  } catch (error) {
    const shouldCheckForTooLargeCookies = isAndroidApp() && window.cookieMaster;
    console.log('shouldCheckForTooLargeCookies', shouldCheckForTooLargeCookies);
    if (shouldCheckForTooLargeCookies) {
      console.error('Failed to fetch short lived token, clearing existing auth token and cookies and retrying openExternalLink', error);
      forceTokenRemoval(error, false);
      if (tries < 3) {
        await openExternalLink(url, openInNewTab, tries + 1);
      } else {
        console.error('Failed to openExternalLink after 3 tries', error);
      }
    }
  }
}

export function openExternalLinkSimple(url, openInNewTab = false) {
  const urlWithDefaultParams = addDefaultQueryParams(url);
  if (window.cordova) {
    window.open(urlWithDefaultParams, '_system');
    return;
  }
  if (!isCordova() && openInNewTab) {
    window.open(urlWithDefaultParams, '_blank');
    return;
  }
  window.location.href = urlWithDefaultParams;
}
